<xemex-dialog-shell [title]="'installations.editor.point.titleRename' | translate">
  <div class="flex flex-col gap-4">
    <xemex-text-field
      [label]="'installations.points.name' | translate"
      [required]="true"
      [invalid]="touched() && nameInvalid()"
      [errorText]="'installations.editor.point.nameInvalid' | translate: { max: nameMaxLength }"
      [ngModel]="name()"
      (ngModelChange)="name.set($event)"
    />

    @if (messageAt('dialog'); as messageKey) {
      <p class="m-0 text-text-error" role="alert">{{ messageKey | translate }}</p>
    }
  </div>

  <div actions class="flex w-full items-center justify-end gap-3">
    <xemex-text-button (click)="cancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-text-button>
    <xemex-filled-button [disabled]="isSaving() || stale()" [loading]="isSaving()" (click)="save()">
      {{ 'general.btnSave' | translate }}
    </xemex-filled-button>
  </div>
</xemex-dialog-shell>
